import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Tag } from 'lucide-react';
import { Resource } from '../../models/Resource';
import styles from './ResourceCard.module.css';

/**
 * ResourceCard component to display individual resource information
 * @param {Object} props - Component props
 * @param {Resource} props.resource - Resource data object
 * @param {boolean} props.loading - Loading state
 */
const ResourceCard = ({ resource, loading = false }) => {
  if (loading) {
    return (
      <div className={styles.resourceCard}>
        <div className={styles.skeleton}>
          <div className={`${styles.skeletonLine} ${styles.skeletonTitle}`}></div>
          <div className={`${styles.skeletonLine} ${styles.skeletonCategory}`}></div>
          <div className={`${styles.skeletonLine} ${styles.skeletonExcerpt}`}></div>
          <div className={`${styles.skeletonLine} ${styles.skeletonExcerpt}`}></div>
          <div className={`${styles.skeletonLine} ${styles.skeletonDate}`}></div>
        </div>
      </div>
    );
  }

  if (!resource) {
    return null;
  }

  const resourceInstance = resource instanceof Resource ? resource : new Resource(resource);

  return (
    <article className={`${styles.resourceCard} ${resourceInstance.featured ? 'has-featured' : ''}`}>
      <Link to={resourceInstance.getUrl()} className={styles.cardLink}>
        <div className={styles.cardContent}>
          {resourceInstance.featured && (
            <div className={styles.featuredBadge}>
              Featured
            </div>
          )}
          
          <div className={styles.categoryTag}>
            {resourceInstance.category.name}
          </div>

          <h3 className={styles.title}>{resourceInstance.title}</h3>
          
          <p className={styles.excerpt}>
            {resourceInstance.getTruncatedExcerpt(120)}
          </p>

          <div className={styles.metadata}>
            <div className={styles.dateInfo}>
              <Calendar size={14} />
              <span>{resourceInstance.getFormattedUpdatedDate()}</span>
            </div>
            
            {resourceInstance.tags.length > 0 && (
              <div className={styles.tags}>
                <Tag size={14} className={styles.tagIcon} />
                <div className={styles.tagsContainer}>
                  {resourceInstance.tags.slice(0, 3).map((tag, index) => (
                    <span key={index} className={styles.tag}>
                      {tag}
                    </span>
                  ))}
                  {resourceInstance.tags.length > 3 && (
                    <span className={styles.tagMore}>
                      +{resourceInstance.tags.length - 3}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      </Link>
    </article>
  );
};

export default ResourceCard;